import { render, staticRenderFns } from "./YardProposalAddressForm.vue?vue&type=template&id=36b199f8&"
import script from "./YardProposalAddressForm.vue?vue&type=script&lang=js&"
export * from "./YardProposalAddressForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports